import { defineMessages } from "react-intl";

export const messages = defineMessages({
    header: {
        id: "UserSeg.twc.workOnFrist.header",
        defaultMessage: "What do you want to work on first?"
    },
    defaultHeader: {
        id: "UserSeg.twc.workOnFrist.header2",
        defaultMessage: "What do you want to start with?"
    },
    subHeader: {
        id: "UserSeg.twc.workOnFrist.subHeader",
        defaultMessage:
            "Choose your template. You can come back to the others anytime."
    },
    defaultSubHeader: {
        id: "UserSeg.twc.workOnFrist.subHeader2",
        defaultMessage: "You'll be able to explore everything else later."
    },
    nextButton: {
        id: "UserSeg.twc.workOnFrist.nextButton",
        defaultMessage: "Next"
    },
    campaigns: {
        id: "UserSeg.twc.workOnFrist.workType.campaigns",
        defaultMessage: "Campaigns"
    },
    events: {
        id: "UserSeg.twc.workOnFrist.workType.events",
        defaultMessage: "Events"
    },
    projectManagement: {
        id: "UserSeg.twc.workOnFrist.workType.projectManagement",
        defaultMessage: "Project management"
    },
    contentStrategy: {
        id: "UserSeg.twc.workOnFrist.workType.contentStrategy",
        defaultMessage: "Content strategy"
    },
    socialMediaPlans: {
        id: "UserSeg.twc.workOnFrist.workType.socialMediaPlans",
        defaultMessage: "Social media plans"
    },
    goalsTracker: {
        id: "UserSeg.twc.workOnFrist.workType.goalsTracker",
        defaultMessage: "Goals tracker"
    },
    processManagement: {
        id: "UserSeg.twc.workOnFrist.workType.processManagement",
        defaultMessage: "Process management"
    },
    taskTracking: {
        id: "UserSeg.twc.workOnFrist.workType.taskTracking",
        defaultMessage: "Task tracking"
    },
    strategicPlan: {
        id: "UserSeg.twc.workOnFrist.workType.strategicPlan",
        defaultMessage: "Strategic plan"
    },
    projectPlan: {
        id: "UserSeg.twc.workOnFrist.workType.projectPlan",
        defaultMessage: "Project plan"
    },
    bugTracking: {
        id: "UserSeg.twc.workOnFrist.workType.bugTracking",
        defaultMessage: "Bug tracking"
    },
    productRoadmap: {
        id: "UserSeg.twc.workOnFrist.workType.productRoadmap",
        defaultMessage: "Product roadmap"
    },
    howToArticle: {
        id: "UserSeg.twc.workOnFrist.workType.howToArticle",
        defaultMessage: "How-to article"
    },
    featureRequests: {
        id: "UserSeg.twc.workOnFrist.workType.featureRequests",
        defaultMessage: "Feature requests"
    },
    productRequirements: {
        id: "UserSeg.twc.workOnFrist.workType.productRequirements",
        defaultMessage: "Product requirements"
    },
    creativeProjects: {
        id: "UserSeg.twc.workOnFrist.workType.creativeProjects",
        defaultMessage: "Creative projects"
    },
    designProcess: {
        id: "UserSeg.twc.workOnFrist.workType.designProcess",
        defaultMessage: "Design process"
    },
    designSprint: {
        id: "UserSeg.twc.workOnFrist.workType.designSprint",
        defaultMessage: "Design sprint"
    },
    meetingNotes: {
        id: "UserSeg.twc.workOnFrist.workType.meetingNotes",
        defaultMessage: "Meeting notes"
    },
    designDecisions: {
        id: "UserSeg.twc.workOnFrist.workType.designDecisions",
        defaultMessage: "Design decisions"
    },
    messageHouse: {
        id: "UserSeg.twc.workOnFrist.workType.messageHouse",
        defaultMessage: "Message house"
    },
    pipelineTracking: {
        id: "UserSeg.twc.workOnFrist.workType.pipelineTracking",
        defaultMessage: "Pipeline tracking"
    },
    leadTracking: {
        id: "UserSeg.twc.workOnFrist.workType.leadTracking",
        defaultMessage: "Lead tracking"
    },
    myMarketingCampaigns: {
        id: "UserSeg.twc.workOnFrist.image.myMarketingCampaigns",
        defaultMessage: "My marketing campaigns illustration"
    },
    mySoftwareProject: {
        id: "UserSeg.twc.workOnFrist.image.mySoftwareProject",
        defaultMessage: "My software project illustration"
    },
    myProductRoadmap: {
        id: "UserSeg.twc.workOnFrist.image.myProductRoadmap",
        defaultMessage: "My product roadmap illustration"
    },
    myDesignProject: {
        id: "UserSeg.twc.workOnFrist.image.myDesignProject",
        defaultMessage: "My design project illustration"
    },
    mySalesPipeline: {
        id: "UserSeg.twc.workOnFrist.image.mySalesPipeline",
        defaultMessage: "My sales pipeline illustration"
    },
    myProject: {
        id: "UserSeg.twc.workOnFrist.image.myProject",
        defaultMessage: "My project illustration"
    }
});
